import getBasePath from '@/utils/path'
import ExtendedFavoritesApi from './ExtendedFavoritesApi'
import ExtendedRecommendationsApi from './ExtendedRecommendationsApi'

let basePath = getBasePath() + '/my-geo'

export function createFavoritesAPIClient (): ExtendedFavoritesApi {
  return new ExtendedFavoritesApi({ basePath })
}

export function createRecommendationsAPIClient (): ExtendedRecommendationsApi {
  return new ExtendedRecommendationsApi({ basePath })
}
